import Page from 'v5/showingsPage/ShowingsPageRelay.bs'
import { withMainLayoutFlex } from '../../pagesComponents/MainApp'
import { requireAuthenticatedAgent } from '../../hoc/AuthenticatedComponent'

const ShowingsPage = requireAuthenticatedAgent(Page)

ShowingsPage.getLayout = withMainLayoutFlex

export default ShowingsPage
